import { computed, makeObservable } from 'mobx'
import type { $Values } from 'utility-types'

import { Model } from 'modules/core/lib/mobx-rest'

import { accessGroups } from 'modules/automations/store/collections/accessGroups'
import { automations } from 'modules/automations/store/collections/automations'
import notifiers from 'modules/automations/store/collections/notifiers'
import { templates } from 'modules/custom_resources/store/collections/customTemplates/templates'

const Types = {
  branch: 'Automations::Actions::Branch',
  requestReview: 'Automations::Actions::RequestReview',
  sendNotification: 'Automations::Actions::SendNotification',
  sendCustomNotification: 'Automations::Actions::SendCustomNotification',
  time: 'Automations::Actions::Time',
}

export type Type = $Values<typeof Types>

export interface IAction {
  id: number
  automations_action_id?: number
  automations_automation_id: number
  actionable_type: Type
  metadata: any
  [key: string]: unknown
}

export class Action extends Model<IAction> {
  static Types = Types

  constructor(attr: IAction) {
    super(attr)
    makeObservable(this, {
      metadata: computed,
      automation: computed,
      accessGroup: computed,
      notifier: computed,
      type: computed,
      subjectTemplate: computed,
      bodyTemplate: computed,
    })
  }

  static urlRoot() {
    return '/automations/actions'
  }

  get metadata(): Record<string, any> {
    return this.attributes.metadata
  }

  get automation() {
    return automations.find({
      id: this.attributes.automations_automation_id,
    })
  }

  get accessGroup() {
    return accessGroups.find({
      automations_action_id: this.attributes.id,
    })
  }

  get notifier() {
    return notifiers.find({
      slug: this.metadata.notifier,
    })
  }

  get type(): Type {
    return this.attributes.actionable_type
  }

  get subjectTemplate() {
    return templates.find({
      id: this.metadata.subject_id,
    })
  }

  get bodyTemplate() {
    return templates.find({
      id: this.metadata.body_id,
    })
  }
}
